export const onlinePurchase = {
  title: 'Купите квартиру онлайн',
  algorithm: [
    {
      title: 'Выберите квартиру',
      text: 'Выбирать квартиру удобно онлайн на pik.ru: отмечайте понравившиеся варианты ❤️ и сравнивайте их в личном кабинете.',
      step: 1,
    },
    {
      title: 'Забронируйте на сайте',
      text: 'Купите квартиру онлайн на pik.ru, забронировав её на 10 дней за 5000 рублей. Вам потребуется только паспорт. На время резерва цена на квартиру не изменится, и никто другой не сможет её купить. А оплатить бронирование можно онлайн сразу после выбора квартиры.',
      step: 2,
    },
    {
      title: 'Оформите ипотеку онлайн',
      text: 'Получите одобрение ипотеки и оформите необходимое страхование на pik.ru — без визитов в банк и страховую. Просто заполните единую анкету, а мы отправим её в банки. Заявку можно подать по двум документам — паспорту и СНИЛС. 98% ипотечных заявок, поданных через сайт ПИК, получают одобрение.',
      step: 3,
    },
    {
      title: 'Оформите сделку онлайн',
      text: 'Сделку можно провести онлайн от начала и до конца. Если вы хотите оформить покупку без использования ипотеки, просто оплатите 100% стоимости квартиры банковской картой онлайн без визита в офис.',
      step: 4,
    },
    {
      title: 'Пользуйтесь личным кабинетом',
      text: 'После покупки вы сможете в любое время получать всю необходимую информацию о вашей квартире. Личный кабинет позволит вам регулярно отслеживать ход строительства. Помимо этого, там будут доступны дополнительные сервисы ПИК.',
      step: 5,
    },
  ],
};
